"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const big_js_1 = __importDefault(require("big.js"));
// Must be named Big since we do constructor name check shenanigans
const Big = function (input) {
    if (input === undefined) {
        return (0, big_js_1.default)();
    }
    let newBig;
    if (typeof input === 'string') {
        newBig = new big_js_1.default(input.replace(/_/g, ''));
    }
    else {
        newBig = new big_js_1.default(input);
    }
    newBig.constructor = Big;
    return newBig;
};
const staticExtensions = {
    fromHrTime: function ([seconds, nanoseconds]) {
        const output = new Big(nanoseconds);
        return new Big(output.pow10(-9).plus(seconds));
    },
    max: function (first, ...rest) {
        return rest.reduce((acc, e) => (acc.gt(e) ? acc : e), first);
    },
    min: function (first, ...rest) {
        return rest.reduce((acc, e) => (acc.lt(e) ? acc : e), first);
    },
};
for (const [key, value] of Object.entries(staticExtensions)) {
    big_js_1.default[key] = value;
}
exports.default = Big;
//# sourceMappingURL=constructor.js.map